import classNames from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, ReactNode } from 'react'

interface ActiveLinkType {
  href?: string
  match?: any
  as?: string
  disabled?: boolean
  activeClassName?: string
  className?: string
  children?: ReactNode
}

const ActiveLink: FC<ActiveLinkType> = ({
  href = '',
  match,
  as = href,
  disabled,
  activeClassName = 'active',
  className,
  children,
}) => {
  const router = useRouter()

  const isActive =
    (!match && router.pathname === href && activeClassName) ||
    (match && router.pathname.match(match))

  if (disabled) {
    return <>{children}</>
  }
  return (
    <Link
      as={as}
      href={href}
      className={classNames(className, isActive && activeClassName)}
    >
      {children}
    </Link>
  )
}

export default ActiveLink
